import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import Key              from "../../../types/Key"
import BlocklistKeyType from "../../../types/BlocklistKey"
import DateTimeListItem from "../../common/ListItems/DateTime";

export interface props {
    blocklistKeyItem?: BlocklistKeyType
    keyItem:           Key
}

const ItemGroupInfo: React.FC<props> = (
    {blocklistKeyItem, keyItem}
) => {

    const { t } = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.info')}</IonItemDivider>
            {blocklistKeyItem &&
            <IonItem lines="full" button={false}>
                <IonLabel>{t('keys.form.blocked_on')}</IonLabel>
                <IonNote className="ion-padding-vertical"  slot="end">{blocklistKeyItem.blocklistedAt}</IonNote>
            </IonItem>
            }
            {keyItem.options?.canHaveExpireDate &&
                <IonItem lines="full">
                    <IonLabel>{t('keys.form.expire_date')}</IonLabel>
                    <IonNote className="ion-padding-vertical" slot="end">{keyItem.expireDate || '-'}</IonNote>
                </IonItem>
            }
            {keyItem.label &&
            <IonItem lines="full">
                <IonLabel>{t('keys.form.label')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{keyItem.label || '-'}</IonNote>
            </IonItem>
            }
            <IonItem lines="full">
                <IonLabel>{t('keys.form.programming_state')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{keyItem.keyProgrammingState?.name || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('keys.form.serial_number')}</IonLabel>
                <IonNote className="ion-padding-vertical"  slot="end">{keyItem.serial || '-'}</IonNote>
            </IonItem>
            {keyItem.externalId &&
                <IonItem lines="full">
                    <IonLabel position="fixed">{t('common.external_id')}</IonLabel>
                    <IonNote className="ion-padding-vertical" slot="end">{keyItem.externalId || '-'}</IonNote>
                </IonItem>
            }
            <DateTimeListItem label={t('common.synced_at').toString()}
                              dateTime={keyItem.meta?.syncedAt} />
        </IonItemGroup>
    )

}

export default ItemGroupInfo